<template>
  <div class="card col-grid-2" @mousemove="boxHover(index)" @mouseout="boxOut" :class="{'hover': hoverNo === index, 'prev': hoverNo > index && index % numberOfCardsInRow !== 0, 'next': hoverNo < index && index % numberOfCardsInRow !== 1, 'first': index % numberOfCardsInRow === 1, 'last': index % numberOfCardsInRow === 0}">
    <component :is="cardType"
      :card="card"
      :hoverNo="hoverNo"
      :index="index"
    >
    </component>
  </div>
</template>

<script>
import Station from './Station'
// import EventCard from './EventCard'

export default {
  name: 'Card',
  components: {
    Station
    // EventCard
  },
  props: {
    card: Object,
    cardType: String,
    setParentClass: {
      type: Function,
      required: true
    },
    setHoverNo: {
      type: Function,
      required: true
    },
    numberOfCardsInRow: Number,
    hoverNo: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    boxHover: Function,
    boxOut: Function
  }
}
</script>
<style scoped lang="scss">
  @import 'uc/_variables';

  .card {
    position: relative;
    backface-visibility: hidden;
    perspective: 1000px;
  }
  .ie, .edge {
    .card {
      backface-visibility: visible;
    }
  }

  //   @media only screen and (min-width: $breakpoint) {
  //     .box.first .box-card,
  //     #first.box .box-card {
  //       left: 10px;
  //     }
  //     .box.last .box-card,
  //     #last.box .box-card {
  //       right: 10px;
  //     }
  //   }

</style>

<style lang="scss">

  // .touch-device {
  //   .now-card-slider .box .box-card {
  //     opacity: 0 !important;
  //     transform: translateY(-50%) scale(0.65) !important;
  //   }
  //   .box-list.hover-first .now-card-slider,
  //   .box-list.hover-middle .now-card-slider,
  //   .box-list.hover-last .now-card-slider {
  //     .box.prev,
  //     .box.next,
  //     .box.hover {
  //       transform: translate3d(0,0,0) !important;
  //       transition: 0s;
  //     }
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/components/cards/Card.vue